import { EnumUtils } from '../../../utils/enum.utils';

export enum EditIntegrationFormContext {
  Create = 'create',
  Edit = 'edit',
}

export namespace EditIntegrationFormContext {
  export function getAllContexts(): EditIntegrationFormContext[] {
    return EnumUtils.GetValues<EditIntegrationFormContext>(EditIntegrationFormContext);
  }

  export function isValid(context: null | string): boolean {
    if (context === null) {
      return false;
    }

    return getAllContexts().includes(context as EditIntegrationFormContext);
  }
}
